<script lang="ts">
  import { getContext } from 'svelte'
  import { twMerge } from 'tailwind-merge'
  type TitleType = {
    id?: string
    title?: string
  }
  type DescType = {
    id?: string
    desc?: string
  }

  interface BaseProps {
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
    role?: string
    color?: string
    withEvents?: boolean
    onclick?: (event: MouseEvent) => void
    onkeydown?: (event: KeyboardEvent) => void
    onkeyup?: (event: KeyboardEvent) => void
  }

  interface CtxType extends BaseProps {}
  interface Props extends BaseProps {
    title?: TitleType
    desc?: DescType
    ariaLabel?: string
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
  }

  const ctx: CtxType = getContext('iconCtx') ?? {}
  const sizes = {
    xs: 'w-3 h-3',
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6',
    xl: 'w-8 h-8'
  }

  export let size: Props['size'] = ctx.size || 'md'
  export let role: Props['role'] = ctx.role || 'img'
  export let color: Props['color'] = ctx.color || 'currentColor'
  //export let withEvents: Props['withEvents'] = ctx.withEvents || false
  export let title: TitleType = {}
  export let desc: DescType = {}

  let ariaDescribedby = `${title.id || ''} ${desc.id || ''}`
  let hasDescription = false

  $: if (title.id || desc.id) {
    hasDescription = true
  } else {
    hasDescription = false
  }
  export let ariaLabel = 'archive solid'
  export let strokeWidth = 2
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  fill="none"
  stroke={color}
  stroke-width={strokeWidth}
  {...$$restProps}
  class={twMerge('shrink-0', sizes[size ?? 'md'], $$props.class)}
  {role}
  aria-label={ariaLabel}
  aria-describedby={hasDescription ? ariaDescribedby : undefined}
  viewBox="0 0 48 48"
>
  {#if title.id && title.title}
    <title id={title.id}>{title.title}</title>
  {/if}
  {#if desc.id && desc.desc}
    <desc id={desc.id}>{desc.desc}</desc>
  {/if}
  <path
    class="a"
    d="M10.3635,4.51A1.9944,1.9944,0,0,0,8.4189,6.5043V41.5056A1.9945,1.9945,0,0,0,10.3635,43.5H37.5867a1.9944,1.9944,0,0,0,1.9944-1.9944V14.4719H31.6036a1.9945,1.9945,0,0,1-1.9446-1.9944V4.5Z"
  /><line class="a" x1="29.5693" y1="4.51" x2="39.5312" y2="14.4719" /><line
    class="a"
    x1="15.838"
    y1="22.928"
    x2="32.1121"
    y2="22.928"
  /><line class="a" x1="15.838" y1="34.994" x2="32.1121" y2="34.994" /><line
    class="a"
    x1="15.838"
    y1="28.961"
    x2="32.1121"
    y2="28.961"
  />
</svg>
